import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, thriweDiscoveryUrl, thriweMarketPlaceUaeUrl, thriweMarketPlaceUrl } from '../../../../../Containers/Config';
import { Constant } from '../../../../../Containers/Helpers/constant';
import apiCall from '../../../apiCall';
import { CREATE_ANNOUNCEMENT, CREATE_ANNOUNCEMENT_ERROR, CREATE_ANNOUNCEMENT_SUCCESS } from '../../../actionType';

function* createAnnouncementForGlobeToyota({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${thriweDiscoveryUrl}/v1/admin/announcement`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        // 'Project-Code': 'GLOBE_TOYOTA',
        ...customHeaders,
      },
      data: payload?.data,
      params: {
        ...payload?.urlParams,
      },
    });

    if (response.status === 200) {
      yield put({
        type: CREATE_ANNOUNCEMENT_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: CREATE_ANNOUNCEMENT_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CREATE_ANNOUNCEMENT_ERROR, payload: error });
  }
}

export function* watchcreateAnnouncementForGlobeToyota() {
  yield takeEvery(CREATE_ANNOUNCEMENT, createAnnouncementForGlobeToyota);
}

function* createAnnouncementForGlobeToyotaSaga() {
  yield all([fork(watchcreateAnnouncementForGlobeToyota)]);
}

export default createAnnouncementForGlobeToyotaSaga;
